import React from 'react'

import { AdminLogin } from '@/features/login/admin'

/**
 * 登录页预览 - 管理端
 *
 * @returns React.ReactNode
 */
export const LoginPreview: React.FC = () => {
  return <AdminLogin isPreview={true} />
}
